export { default as SearchLocation } from './SearchLocation';



// WEBPACK FOOTER //
// ./src/components/FormControls/SearchLocation/index.tsx